export default "__VITE_ASSET__CMcs3FZU__"